import styled from "styled-components";

type StyledProps = {
  isDragActive?: boolean;
};

export const Wrapper = styled.div<StyledProps>`
  border: ${({ isDragActive, theme }) =>
    isDragActive
      ? `dashed 2px ${theme.default.color.primary}`
      : `dashed 1px${theme.default.color.text.light}`};
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.4rem;
  cursor: pointer;
  font-size: 12px;
  margin: 1rem 0;
  background: ${({ isDragActive, theme }) =>
    isDragActive
      ? theme.default.color.backgrounds.blue
      : theme.default.color.backgrounds.white};

  &:hover {
    border: ${({ theme }) => `dashed 1px ${theme.default.color.primary}`}
  }

  &:invalid {
    border: ${({ theme }) => `dashed 1px red`}
  }

  &:focus {
    border: ${({ theme }) => `dashed 2px ${theme.default.color.primary}`}
  }
  

  svg {
    font-size: 36px;
    margin-bottom: 1rem;
  }
  span {
    border-bottom: ${({ theme }) => `1px solid ${theme.default.color.text.dark}`};
  }
  p {
   font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-size: 10px;
    font-style: normal;
    font-weight: 900;
    line-height: 22px;
    letter-spacing: 0.05em;
    text-align: center;
    margin: 0;
  }
`;
